module.exports = __webpack_public_path__ + "static/img/5.f9f3185.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/sp/5.png
// module id = X330
// module chunks = 0